// Copyright (c) 2018 Comsearch, Inc., All rights reserved

/* global VERSION */

import React from 'react'
import { string } from 'prop-types'
import { connect } from 'react-redux'

// shows current versions of this UI and the API we're talking to.
// NOTE - VERSION is defined by the UI's pom.xml
// whereas version is from the API and it reflects the API's version

const wrapperStyles = {
  borderTop: '1px solid',
  fontSize: '.75rem',
}

const rowClasses = 'display-block text-overflow-ellipsis white-space-nowrap overflow-hidden'

const Versions = ({ version }) => (
  <p
    className={'text-white main-font padding-top-half'}
    style={wrapperStyles}>
    <span id={'application-version-info-heading'}>{'Versions'}</span>
    <span
      className={`margin-top-half margin-bottom-half ${rowClasses}`}
      title={VERSION}>
      <span
        className={'padding-right-half'}
        id={'application-version-info-ui-label'}>
        {'UI: '}
      </span>
      <span id={'application-version-info-ui-value'}>{VERSION}</span>
    </span>
    <span
      key={'versions-API'}
      className={rowClasses}
      title={version}>
      <span
        className={'padding-right-half'}
        id={'application-version-info--label'}>
        {'API: '}
      </span>
      <span id={'application-version-info-api-value'}>{version}</span>
    </span>
  </p>
)

Versions.propTypes = {
  version: string,
}

const mapStateToProps = ({ applicationSettings }) => ({
  version: applicationSettings.get('version'),
})

export default connect(
  mapStateToProps,
)(Versions)
